import { msg } from "@lingui/core/macro";

export const maxPermitsPerTenantRuleMessages = {
	name: msg({ message: "Maximum Permits Per Tenant" }),
	description: msg({ message: "The maximum amount of permits a tenant may have" }),
	errors: {
		limitReached: msg({
			message:
				"This Tenant has reached its maximum number of permits ({amount}). Delete or update an existing permit.",
		}),
		globalLimitReached: msg({
			message:
				"This Tenant has reached its maximum number of permits ({amount}). Delete or update an existing permit.",
		}),
	},
} as const;
